/* eslint-disable max-lines */
/* eslint-disable max-len */

export default {
  lang: 'pt',
  homeScreen: {
    title: '',
    stayConnected: 'Fique conectado(a)',
    comingSoon: 'Em breve',
    downloadNow: 'Baixe agora:',
    readMore: 'Ler mais ',
  },
  sharing: {
    email: 'E-mail',
    download: 'Baixar',
    copyURL: 'Copiar link',
    copied: 'Copiado',
    shareSubjectBadge: 'Distintivo de Especialista nos EUA',
  },
  shareSubjectDiploma: 'Diploma de Especialista nos EUA',
  loginScreen: {
    version2: {
      accountCreated: 'Uma conta foi criada, verifique seu e-mail para concluir o processo.',
      homeTitle: 'Vamos tentar encontrar um perfil existente para você em nosso sistema.',
      homeTitleSub: 'Insira o endereço de e-mail que você normalmente usa para entrar em programas de treinamento.',
      noAccount: 'Nenhuma conta encontrada para ({email}). Tente com outro e-mail ou crie uma conta agora.',
      continueButton: 'Continuar',
      success: 'Sua conta foi atualizada com sucesso! Redirecionaremos você em breve para a página inicial.',
      successNewAccount: 'Para concluir o registro, você receberá um e-mail de confirmação para verificar sua conta.',
      loginButton: 'Login',
      matchFound: 'Encontramos uma correspondência. Insira sua senha para continuar.',
      magicLink: 'Faça login através de um link por e-mail:',
      magicLinkButton: 'Solicitar link mágico',
      magicLinkTitle: 'Receba um link direto em seu e-mail para entrar instantaneamente.',
      otherEmailButton: 'Enviar',
      title:
        'Reserve um momento para inserir todas as informações abaixo, pois elas completarão seu perfil pessoal e informações de contato.',
      titleIndustry:
        'Reserve um momento para inserir todas as informações abaixo, pois elas completarão seu perfil pessoal e informações de contato.',
      register: 'Criar uma conta',
      agent: 'Consultor(a) de viagens',
      visitor: 'Visitante do setor',
      step1: 'Primeiro passo: Tipo de usuário',
      step2: 'Segundo passo: Criar uma conta',
      step3: 'Terceiro passo: Criar seu perfil',
      marketingOptIn:
        'Tem certeza de que não tem interesse em manter contato com a equipe de comércio de viagens deste programa?',
      optIn: 'Sim, tenho interesse',
      optOut: 'Não tenho interesse',
      step2Sub1: 'Fale sobre você',
      step2Sub2: 'Fale sobre seu negócio',
      privacyHead: 'PREFERÊNCIAS DE COMUNICAÇÃO',
      privacySub:
        'Marque as caixas abaixo para confirmar o recebimento de comunicações importantes da equipe de comércio de viagens do fornecedor (atualizações e anúncios de produtos, recompensas, incentivos, famtours, etc.) e iniciativas de suporte de vendas e networking de comércio de viagens da TravPRO Mobile.',
      privacy: 'Protegemos sua privacidade e nunca vendemos, usamos indevidamente ou traímos sua confiança.',
      store: 'Baixe facilmente este programa em sua loja de aplicativos:',
      powered: 'DESENVOLVIDO POR',
      toastMessage: {
        forgotSuccess:
          'Enviamos o link para redefinição de sua senha por e-mail! Redirecionaremos você para a página de login em 10 segundos.',
        emailNotExisting: 'O endereço de e-mail inserido não existe.',
        magicLinkMessage: 'Aguarde, estamos conectando você agora mesmo.',
        magicLinkError:
          'Não foi possível encontrar sua conta em nosso banco de dados. Faça login manualmente. Redirecionaremos você em 10 segundos.',
        magicLinkError1:
          'Não foi possível encontrar um token válido. Faça login ou solicite um novo link mágico. Se o problema persistir, entre em contato conosco em: info@travpromobile.com.',
        magicLinkError2:
          'Não foi possível encontrar sua conta em nosso banco de dados. Faça login manualmente. Redirecionaremos você em 10 segundos.',
        magicLinkSuccess: 'Verifique seu e-mail em {email}. Enviamos para ele um link mágico para realizar o login.',
        magicLinkErrorWait: 'Aguarde 5 minutos entre as solicitações de link mágico.',
        emailNotFoundError:
          'Não foi possível encontrar o endereço de e-mail que você inseriu em nossos registros. Verifique se há erros ortográficos ou crie uma conta.',
      },
      errors: {
        zipCodeNotFound: 'CEP não encontrado. Tente novamente',
        zipCodeOnlyNumbers: 'O CEP pode conter somente números',
        password: 'Insira uma senha',
        passwordNotMatching: 'As senhas digitadas são diferentes',
        passwordTooShort: 'A senha precisa ter pelo menos 8 caracteres',
        emailExists:
          'Este endereço de e-mail já está cadastrado ou é inválido. Tente com outro endereço de e-mail ou faça login na sua conta.',
        fillInAllFields: 'Preencha todos os campos obrigatórios',
        fillInEmail: 'Insira seu e-mail.',
        emailNotExisting: 'O endereço de e-mail inserido não existe.',
      },
      fields: {
        forgotSubCopy: 'Esqueceu a senha e deseja alterá-la? ',
        forgotSubCopy2:
          'Deseja ignorar totalmente a senha? Enviaremos um e-mail com um link mágico que conectará você automaticamente ao programa. ',
        city: 'Cidade',
        companyName: 'Nome da empresa',
        role: 'Seu cargo (selecione um)',
        description: 'Qual a melhor descrição do negócio da sua empresa?',
        country: 'País',
        password: 'Senha',
        passwordRegister: 'Escolha a senha (mínimo de 8 caracteres)',
        passwordConfirm: 'Confirme a senha',
        firstName: 'Nome',
        lastName: 'Sobrenome',
        agency: 'Nome da agência',
        title: 'Seu cargo (selecione um)',
        company: 'Nome da empresa',
        select: 'Selecione uma opção abaixo',
        state: 'Estado',
        province: 'Província/Região/Estado',
        zipCode: 'CEP',
        postalCode: 'Código postal',
        affiliate: 'Qual grupo é sua afiliação PRINCIPAL à agência?',
        hostAgency: 'Sua agência?',
        executive: 'Executivo',
        management: 'Gerência',
        marketing: 'Marketing',
        sales: 'Vendas',
        coordinator: 'Coordenação',
        opt: 'Mantenha-se conectado à equipe da Brand USA e receba atualizações do Programa USA Discovery',
        optMarketing: 'Fique conectado à TravPRO para saber sobre programas de aprendizado adicionais',
        retail: 'Loja de varejo',
        home: 'Agente autônomo',
        independent: 'Profissional autônomo',
        host: 'Agência',
        call: 'Agência baseada em call center ou na Web',
        other: 'Outro ',
        describes: 'O que melhor descreve você e as atividades da sua agência? ',
      },
    },
    title: 'Programa de treinamento profissional em viagens e capacitação de vendas',
    welcome: {
      headerTop: 'Boas-vindas ao',
      headerBottom: 'USA Discovery Program',
    },
    sellingPoints: {
      0: 'Aprenda, promova e venda em qualquer lugar',
      1: 'Treinamento multimídia em vários dispositivos',
      2: 'Certificado de conclusão',
      3: 'Distintivos de Experiências e de Parceiro',
      4: 'Materiais promocionais compartilháveis',
      5: 'Recursos de vendas 24 horas por dia, 7 dias por semana',
      6: 'Recompensas de treinamento',
      7: 'Incentivos e MegaFams',
    },
    tAndC: {
      agree: 'Ao continuar, você concorda com nossa ',
      privacyPolicy: 'política de privacidade',
      and: ' e ',
      termsConditions: 'termos e condições',
    },
    fields: {
      select: 'Selecione uma opção abaixo',
      country: 'País',
      agency: 'Agência',
      email: 'E-mail',
      password: 'Senha',
      passwordConfirm: 'Confirme sua senha',
      firstName: 'Nome',
      lastName: 'Sobrenome',
      address: 'Endereço',
      postalCode: 'CEP',
      city: 'Cidade',
      agencyName: 'Nome da agência',
      stateProvince: 'Estado/Província',
      required: 'Obrigatório',
      invalidEmail: 'Endereço de e-mail inválido',
      opt: 'Fique por dentro! Sim, gostaria de receber comunicações da Brand USA que me manterão por dentro de notícias, eventos, incentivos, famtours e muito mais!',
      forgot: 'Esqueceu a senha? Clique no botão abaixo e enviaremos um e-mail para redefinir sua senha.',
    },
    forgot: 'Redefinir senha',
    noAgent: {
      noAgentButton: 'Não sou um(a) agente',
      title: 'Agradecemos seu interesse no USA Discovery Program.',
      messageWeb:
        'O conteúdo deste site é exclusivo para profissionais de viagens. \n Para saber mais sobre a Brand USA, visite: ',
      messageMobile:
        'Parte do conteúdo deste aplicativo é exclusivo para profissionais de viagens, mas fique à vontade para ver uma prévia do que este aplicativo tem a oferecer tocando em “Continuar”.',
      continue: 'Continuar',
      visitWebsite: 'Visitar o site',
    },
    newUser: 'Novo usuário',
    register: 'Registrar',
    registered: 'Este e-mail já está registrado',
  },
  welcomeScreen: {
    title: 'Boas-vindas ao USA Discovery Program',
    helloUser: 'Olá, {{name}}',
    hello: 'Olá,',
    fromAgency: 'da {{agency}}',
    notUser: 'Não é {{name}}?',
    startTraining: 'Começar a aprender',
    continueTraining: 'Continuar aprendendo',
    graduated: 'Parabéns!',
    downloader: {
      stop: 'parar',
      init: 'Inicializando...',
      lastUpdate: 'Última atualização: ',
    },
  },
  trainingScreens: {
    comingSoon: 'Em breve: {title}',
    categoryLockMinimum: 'Desbloqueie pelo menos {number} treinamentos incluídos para acessar esta categoria.',
    allUnlocked: 'Você desbloqueou todos os capítulos!',
    completedBase: 'Parabéns, você é um(a) Especialista certificado(a) nos EUA!',
    certificate: 'Certificado',
    chapter: 'Capítulo',
    chapterComplete: 'Capítulo concluído!',
    choose: 'Escolha uma resposta',
    confirm: 'Confirme sua resposta',
    continue: 'Continuar',
    courseComplete: 'Curso concluído!',
    durationInMinutes: '{number} minutos',
    endReached: 'Você chegou ao fim',
    essential: 'O Fundamento',
    essentialSub: 'Conclua esses capítulos essenciais para obter seu diploma e desbloquear as especializações abaixo.',
    message: '{count} mensagem',
    messagePlural: '{count} mensagens',
    percentageComplete: '{number}% concluído',
    restart: 'Revisão',
    review: 'Revisão',
    retainEnd: 'Use a barra superior para navegar neste capítulo ou pressione o botão Voltar para retornar ao resumo.',
    retry: 'Tente novamente',
    skip: 'Voltar >',
    viewAllTitle: 'Dica de treinamento',
    badge: 'Baixar distintivo',
    viewAll:
      'Antes de prosseguir para a próxima página, reserve um momento para revisar todo o conteúdo aqui, incluindo os ícones, pois eles oferecem informações adicionais para ajudar você a se tornar um(a) Especialista.',
    start: 'Iniciar',
    status: 'Status atual:',
    trouble: 'Parece que você está com dificuldades. Releia o conteúdo da(s) página(s) anterior(es) e tente novamente.',
    unlockDefault: 'Desbloqueie este capítulo concluindo o anterior.',
    unlock: 'Desbloqueie este capítulo concluindo o capítulo de treinamento.',
    unlockSubtitle: 'Desbloqueie mais capítulos concluindo os capítulos de treinamento.',
    unlockFoundation: 'Desbloqueie esses capítulos concluindo o Fundamento.',
    watchListenRead: 'Assista, ouça e leia mais',
    completed: 'Concluído',
  },
  trainingExtraScreens: {
    subtitle: 'AS EXPERIÊNCIAS',
    error: 'Opa. Algo deu errado',
    uncompletedTitle: 'EXPERIÊNCIAS NÃO CONCLUÍDAS DE {partner}',
    completedTitle: 'EXPERIÊNCIAS CONCLUÍDAS DE {partner}',
    noAvailableBadges: 'No momento, ainda não há distintivos disponíveis.',
    interimScore: 'Conclua',
    interimScoreEnd: 'mais capítulos para ganhar seu distintivo.',
    badgesComplete: 'Parabéns! Você ganhou seu distintivo:',
  },
  newTrainingFlow: {
    partnerModules: 'ESPECIALIZAÇÕES DE PARCEIROS',
    finishGold: 'Conheça nossos Parceiros e ganhe distintivos ao concluir esses capítulos.',
  },
  points: {
    complete: {
      chapter: 'Capítulo concluído!',
      'intro-chapter': 'Capítulo de Introdução concluído!',
      'sub-app': 'SubApp concluído!',
      rewards: 'Recompensas concluídas!',
    },
    completed: 'Distintivos obtidos {completed}',
  },
  nav: {
    home: 'Início',
    train: 'Treinar',
    learn: 'Treinar',
    retain: 'Reter',
    promote: 'Promover',
    sell: 'Vender',
    info: 'Informações',
    rewards: 'Recompensas',
    media: 'Mídia',
    favorites: 'Favoritos',
    contact: 'Fale conosco',
    diploma: 'Diploma',
    accountSettings: 'Configurações de conta',
    messages: 'Mensagens',
    search: 'Buscar',
    showcases: 'Vitrinas',
  },
  contentHeaders: {
    subapps: 'ESPECIALIZAÇÕES DE PARCEIROS',
    maintrainings: 'Localizações',
    subtrainings: 'As Experiências',
  },
  pageDescriptions: {
    train: 'Eduque, envolva-se e torne-se um(a) Especialista.',
    retain: 'Retenha seu conhecimento de especialista com este recurso de conteúdo fácil de usar.',
    promote:
      'Compartilhe esses itens para despertar interesse e iniciar uma conversa com clientes e clientes potenciais.',
    sell: 'Responda às perguntas dos clientes e interaja com a Brand USA.',
    favorites: 'Seu conteúdo favorito.',
    search: 'Explore todo o conteúdo',
    subapps: 'Conheça nossos Parceiros e ganhe distintivos ao concluir esses capítulos.',
    subtrainings: 'Aprimore seus conhecimentos e ganhe uma distintivos para cada seção abaixo.',
  },
  general: {
    website: 'https://www.thebrandusa.com/',
    forgot: 'Esqueceu a senha?',
    next: 'Avançar',
    yes: 'Sim',
    no: 'Não',
    previous: 'Anterior',
    submit: 'Enviar',
    register: 'Registrar',
    back: 'Voltar',
    close: 'Fechar',
    page: 'Página',
    search: 'Buscar',
    logIn: 'Entrar',
    logOut: 'Sair',
    viewItem: 'Ver {type}',
    imageNotFound: 'Imagem não encontrada',
    noResultsFor: 'Nenhum resultado encontrado',
    noFavorites: 'Você ainda não tem favoritos.',
    noMessages: 'Você ainda não recebeu nenhuma mensagem.',
    resultsFor: 'Resultados para: {{query}}',
    showAll: 'Mostrar tudo',
    connectionError: 'Erro de conexão',
    alreadyExists: 'Já existe',
    pageNotFound: 'Página 404 não encontrada!',
    oops: 'Opa...',
    overview: 'Voltar ao resumo',
    complete: 'Continuar',
    courseComplete: 'Capítulo concluído!',
    chapterComplete: 'Capítulo concluído!',
    message: 'Mensagem ({count})',
    messagePlural: 'Mensagens ({count})',
  },
  itemTypes: {
    image: 'Imagem',
    brochure: 'Coleção',
    layout: 'Layout',
    web: 'Site',
    pdf: 'PDF',
    carousel: 'Coleção',
  },
  questions: {
    dials: 'Gire os discos para corresponder à resposta',
    fitb: 'Preencha o(s) espaço(s) em branco',
    flip: 'Altere o número para corresponder à resposta',
    multipleChoice: 'Escolha a(s) resposta(s) correta(s)',
    slider: 'Escolha a resposta correta usando o controle deslizante',
    map: 'Responda à pergunta tocando no local correto no mapa',
    dropdown: 'Escolha...',
    true: 'Verdadeiro',
    false: 'Falso',
  },
  reportCard: {
    download: 'Baixar',
    email: 'E-mail',
    print: 'Imprimir',
  },
  cookies: {
    consent: 'CONCORDAR',
    optout: 'Recusar',
    settings: 'Configurações de privacidade',
    message:
      'Você não informou suas preferências de privacidade de dados! Tudo bem, mas gostaríamos de oferecer a melhor experiência usando o Sales Companion.',
    disabled: 'Parece que você desativou o uso de cookies.',
    use: 'O {{appName}} requer o uso de cookies para oferecer a melhor experiência.',
    details: 'Para que servem os cookies?',
    enable: 'Veja como habilitar os cookies {{here}}.',
    here: 'aqui',
  },
  notLoggedIn: {
    super: 'Você não está conectado',
    title: 'Você precisa estar conectado para ver este conteúdo',
    guest: 'Convidado',
  },
  demo: {
    message:
      'Este site é uma demonstração do produto final. No momento, ele está em desenvolvimento e não é um produto completo.',
    consent: 'Entendido!',
  },
  share: {
    header: 'Compartilhe este recurso em sua rede social favorita!',
    download: 'Baixar',
    email: 'E-mail',
  },
  breadCrumbs: {
    page: 'Página',
  },
  storeButtons: {
    title: 'Instale o aplicativo em seu dispositivo móvel',
  },
  onMobile: {
    header: 'Parece que você está tentando acessar o aplicativo {appName} em um dispositivo móvel',
    body: 'Para baixar este programa, basta visitar sua loja de aplicativos e buscar por {appName} ou clicar em um dos botões abaixo',
    benefits: {
      1: 'Aprenda, promova e venda em qualquer lugar',
      2: 'Treinamento multimídia em vários dispositivos',
      3: 'Certificado de conclusão',
      4: 'Distintivos de Experiências e de Parceiro',
      5: 'Materiais promocionais compartilháveis',
      6: 'Recursos de vendas 24 horas por dia, 7 dias por semana',
      7: 'Recompensas de treinamento',
      header: 'Isso proporcionará a você:',
    },
  },
  custom: {
    splitUsers: 'Sou um(a)...',
    brandAmbassador: 'Embaixador(a) da marca',
    travelPro: 'Profissional de viagens',
  },
  rewards: {
    menu: {
      home: 'Início\nRecompensas',
      achievements: 'Conquistas\nTreinamento',
      bookings: 'Incentivos\nDistintivos',
      form: 'Enviar\nReservas',
    },
    required: {
      rezsnap: 'Envio de prova RezSnap™ necessário',
    },
    rewards: 'Recompensas',
    title: 'Boas-vindas ao Centro de Recompensas e Conquistas',
    subheader: 'Acompanhe e compartilhe conquistas e incentivos de treinamento',
    button: 'Envie sua reserva',
    viewAllBookings: 'Reservas',
    viewDashboard: 'Painel de pontos',
    viewRewards: 'Visão geral',
    overview: {
      valid: '*As reservas inseridas são válidas somente após a viagem do cliente ser concluída.',
    },
    home: {
      entries: 'Entradas atuais',
      trainingAchievements: 'CONQUISTAS DE TREINAMENTO',
      trainingAchievementsText:
        'Acompanhe o progresso do seu treinamento, certificações e status do ranking de recompensas nesta página. Você também poderá baixar e compartilhar seu diploma de Especialista nos EUA, bem como quaisquer distintivos que tenha conquistado em Experiências e Especializações de Parceiros.',
      bookingContests: 'PAINEL DE INCENTIVOS',
      bookingContestsText:
        'Acompanhe e gerencie facilmente os programas de incentivos atuais no Painel de incentivos. ',
      submitBooking: 'ENVIAR RESERVAS',
      submitBookingText: 'Aqui você enviará reservas para inclusão em Incentivos de reserva.',
      currentContest: 'INCENTIVOS ATUAIS',
      noContests: 'Não há Incentivos de distintivos atuais.',
      ContestEndDate: 'Fim do incentivo:',
      ContestDetails: 'Detalhes do incentivo',
      ContestSeeProgram: 'Termos e condições do programa',
      ContestTerms: 'Termos e condições do programa',
      ContestForDetails: 'para mais detalhes.',
      ContestPartnerLink: 'Ir para o Parceiro',
      ContestLink: 'Ir para o link',
    },
    bookingsView: {
      title: 'Reservas',
      infoMessage:
        'Classifique usando os botões acima e clique em qualquer registro para gerenciar os detalhes do envio. Todos os registros pendentes serão verificados dentro de 72 horas',
    },
    leaderboardScreen: {
      prizes: 'Prêmios',
      tAndC: 'Aplicam-se Termos e condições*',
    },
    dashboardView: {
      title: 'Painel de incentivos',
      subtitle: 'Acompanhe suas atividades de incentivos aqui.',
      badge: 'Incentivos de distintivo',
      activity: 'Incentivos de reserva',
      manage: 'Gerenciar reservas',
      manageSub:
        'Acompanhe as reservas atuais abaixo ou veja as reservas arquivadas usando o menu suspenso.',
      noBadgeIncentives: 'Não há Incentivos de distintivos atuais.',
      noBookings: 'Não há registros para exibir.',
      state: {
        approvedEntries: 'Entradas Aprovadas',
        pendingEntries: 'Entradas Pendentes',
        declinedEntries: 'Entradas Recusadas',
        viewAll: 'Ver Tudo',
      },
      currentYear: 'Ano Atual',
      archivedBookings: 'Reservas Arquivadas',
    },
    bookingForm: {
      title: 'Formulário de crédito de reserva nos EUA',
      subTitle: 'Insira sua reserva:',
      required: '* Indica um campo obrigatório',
      email: 'E-mail do(a) consultor(a)',
      agentFirstName: 'Nome do(a) consultor(a)',
      agentLastName: 'Sobrenome do(a) consultor(a)',
      company: 'Agência/Nome da empresa',
      iata: 'Número IATA/CLIA',
      stateProvince: 'Estado/Província',
      postalCode: 'CEP/Código postal',
      country: 'País',
      city: 'Cidade',
      birthday: 'Aniversário',
      type: 'Tipo de viagem do hóspede',
      source: 'Fonte da reserva',
      tourOperator: 'Operadora de turismo',
      firstName: 'Nome do hóspede',
      lastName: 'Sobrenome do hóspede',
      confirmNumber: 'Número de confirmação da reserva/Número PNR',
      ticketNumber: 'Número do bilhete',
      file: 'Envio de prova da RezSnap™ ',
      arrivalDate: 'Data de chegada à propriedade',
      departureDate: 'Data de saída da propriedade',
      brand: 'Marca reservada',
      lengthOfStay: 'Duração da estadia',
      cost: 'Custo total da reserva',
      rooms: 'Número de quartos',
      airline: 'Companhia aérea/Transportadora (código de 2 dígitos)',
      gateway: 'Portão de origem (código de aeroporto de 3 letras)',
      destination: 'Destino/ilha (código do aeroporto de 3 letras)',
      disclaimer: '* Campos obrigatórios',
      button: 'Envie sua reserva',
      sub: 'Seus dados',
      sub2: 'Informações de reserva',
      travelDepartureDate: 'Data de partida da viagem',
      travelReturnDate: 'Data de retorno da viagem',
      flightNumber: 'Número do voo com destino aos EUA',
      numberOfTravelers: 'Número de viajantes no grupo',
      edit: 'Editar seus dados',
      fileUploaded: 'O arquivo foi enviado com sucesso',
      select: 'Selecione uma opção abaixo',
      drag: 'Arraste ou clique aqui para carregar um arquivo.',
      fileType: '(Será aceite um ficheiro, ficheiros .jpeg, .png e .pdf. O tamanho máximo do ficheiro é de 100 MB).',
      maxSize: 'O tamanho máximo do arquivo é 100 MB',
    },
    TermsAndConditions: {
      title: 'Termos e condições do programa',
      subTitle: 'Recompensas trimestrais de Especialista',
      body1:
        'Todos os lançamentos devem ser acompanhados de um comprovante de venda com saldo zero que corresponda a cada reserva individual listada. Os premiados serão selecionados com base na totalidade dos documentos comprobatórios de venda verificados correspondentes a cada reserva listada. Os lançamentos devem seguir todos os requisitos do USA Discovery Program.',
      body2:
        'Para ser elegível, você deve residir nos EUA, ou pela Brand USA, e ser maior de idade conforme as leis do estado, província ou território de residência. Funcionários de operadoras de turismo NÃO são elegíveis para sorteios e NÃO serão considerados para prêmios adicionais. Residentes da província de Quebec NÃO são elegíveis para sorteios e NÃO serão considerados para prêmios adicionais.',
      body3:
        'A emissão de recompensas pode exigir prova de credenciamento como consultor(a) de viagens de varejo/autônomo(a). As recompensas disponíveis estão sujeitas a alterações no decorrer do programa.',
      body4: 'Privacidade e uso de informações pessoais',
      body5:
        'Os agentes participantes (i) concedem ao Premiador o direito de usar seu nome, cidade, estado, província, código postal, confirmação de maioridade, número de telefone e endereço de e-mail para, entre outros, entrar em contato e anunciar os Premiados e a distribuição dos prêmios; (ii) concedem ao(à) Premiado(a) o direito de usar seus dados pessoais para fins publicitários e promocionais relacionados aos prêmios, em qualquer e todos os meios de comunicação agora conhecidos ou posteriormente criados, sem compensação adicional, a menos que proibido por lei; e (iii) reconhecem que os Premiados podem divulgar seus dados pessoais a agentes terceirizados e prestadores de serviços relacionados a qualquer uma das atividades listadas em (i) e (ii) acima.',
      button: 'Retornar à página inicial',
    },
    thankYouPage: {
      thanks: 'Obrigado',
      congrats: 'Parabéns, ',
      body: 'sua reserva foi recebida e enviada ao supervisor da campanha para verificação.',
      link: 'Observe que, para ser um(a) ganhador(a), você deve ter concluído o Fundamento no USA Discovery Program',
    },
  },
  facts: {
    title: 'Você sabia?',
  },
  badgeView: {
    other: 'Parceiros Regionais',
    unlock: 'Comece a completar itens de treinamento para receber distintivos',
    title: 'Conquistas de Treinamento',
    subtitle:
      'Bem-vindo ao seu painel de Conquistas, onde você pode visualizar, acompanhar e baixar seu diploma e distintivos de especialização.',
    viewBadge: 'Ver Status',
    badgeDisplayTitle: 'STATUS DE RECOMPENSAS METÁLICAS',
    badgeAchievement:
      'Você alcançou o Status {rank}! Clique no ícone à direita para visualizar e compartilhar seu status.',
    badgesCompleteTitle: 'Seus distintivos de especialização',
    badgesCompleteSubtitle: 'Clique nos ícones para visualizar, salvar e compartilhar seus distintivos.',
    badgesIncompleteSubtitle: 'Obtenha mais distintivos completando estes capítulos.',
    bronze: 'Bronze',
    silver: 'Prata',
    gold: 'Ouro',
    platinum: 'Platina',
    diploma: 'Diploma',
    complete: 'COMPLETO',
  },
  missing: {
    discover: 'Descobrir',
    pacific: 'Pacífico',
    west: 'Oeste',
    southwest: 'Sudoeste',
    midwest: 'Centro-Oeste',
    south: 'Sudeste',
    northeast: 'Nordeste',
    territories: 'Territórios',
    shoppingAttractions: 'Compras & Atrações',
    gettingAround: 'Deslocando-se',
    regionalPartners: 'Parceiros Regionais',
    greatOutdoors: 'Grandes Áreas Externas',
    winterSports: 'Esportes de Inverno',
    coastalEscapes: 'Fugas Costeiras',
    flyDrive: 'Fly-Drive',
    foodDrink: 'Comida & Bebida',
    luxury: 'Luxo',
    musicCultureHeritage: 'Música, Cultura & Patrimônio',
    nationalParks: 'Parques Nacionais',
    regionMap: 'Mapa da Região',
    videos: 'Vídeos',
    images: 'Imagens',
    incentives: 'Incentivo',
    southeast: 'Sudeste',
  },
};
